import * as Actions from './tags.constants';
import ReducerCreator from '../registerReducer';
import { StoreItem } from '../Store';
import { TagDefinition } from '../../models/';
import { APPLICATION_DISCONNECTED } from '../application/application.constants';
import { buildStoreItem, copyStoreItem, buildErrorItem } from '../storeItemBuilder';

const r = new ReducerCreator<TagDefinition>()
    .register<string>(APPLICATION_DISCONNECTED, (state, payload) => {
        return new StoreItem<TagDefinition>();
    })
    .register<TagDefinition[]>(Actions.TAGS_CLEAR, (state, payload) => {
        return new StoreItem<TagDefinition>();
    })
    .register<TagDefinition[]>(Actions.TAGS_LOAD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<TagDefinition[]>(Actions.TAG_LOAD, (state, payload) => {
        const newState = copyStoreItem(state.dictionary);
        newState.isLoading = true;
        newState.isLoaded = false;
        return newState;
    })
    .register<TagDefinition[]>(Actions.TAGS_LOAD_SUCCESS, (state, tags) => {
        return buildStoreItem(tags);
    })
    .register<TagDefinition>(Actions.TAG_LOAD_SUCCESS, (state, tag) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        newStoreItem.dictionary[tag.guid] = tag;
        return newStoreItem;
    })
    .register<any>(Actions.TAGS_LOAD_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    })
    .register<TagDefinition>(Actions.TAG_CREATE_SUCCESS, (state, tag) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        newStoreItem.dictionary[tag.guid] = tag;
        return newStoreItem;
    })
    .register<TagDefinition[]>(Actions.TAGS_SAVE_SUCCESS, (state, tags) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        tags.forEach(t => newStoreItem.dictionary[t.guid] = t);
        return buildStoreItem(tags);
    })
    .register<TagDefinition[]>(Actions.TAGS_UPDATE_SUCCESS, (state, tags) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        tags.forEach(t => newStoreItem.dictionary[t.guid] = t);
        return newStoreItem;
    })
    .register<any>(Actions.TAGS_UPDATE_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    })
    .register<any>(Actions.TAGS_DELETE_ERROR, (state, reason) => {
        return buildErrorItem(reason);
    })
    .register<TagDefinition[]>(Actions.TAGS_DELETE_SUCCESS, (state, deleted) => {
        const newStoreItem = copyStoreItem(state.dictionary);
        deleted.forEach(t => delete newStoreItem.dictionary[t.guid]);
        return newStoreItem;
    })
    ;
    
export function tagsReducer(
    state: StoreItem<TagDefinition> = new StoreItem<TagDefinition>(),
    action: { type: string, payload: any }
) {
    return r.reduce(state, action);
}